import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractBreakConditionListStatus: 'idle',
    loadContractBreakConditionListError: undefined as any,
    loadContractBreakConditionListLastArgs: undefined as any,
    loadContractBreakConditionStatus: 'idle',
    loadContractBreakConditionError: undefined as any,
    loadContractOptionConditionListStatus: 'idle',
    loadContractOptionConditionListError: undefined as any,
    loadContractOptionConditionListLastArgs: undefined as any,
    loadContractOptionConditionStatus: 'idle',
    loadContractOptionConditionError: undefined as any,
    saveContractBreakConditionStatus: 'idle',
    saveContractBreakConditionError: undefined as any,
    saveContractOptionConditionStatus: 'idle',
    saveContractOptionConditionError: undefined as any,
    deleteContractBreakConditionStatus: 'idle',
    deleteContractBreakConditionError: undefined as any,
    deleteContractOptionConditionStatus: 'idle',
    deleteContractOptionConditionError: undefined as any,
    getIsContractBreakConditionValidPeriodEnabledStatus: 'idle',
    getIsContractBreakConditionValidPeriodEnabledError: undefined as any,
    getIsContractBreakConditionPeriodTypeEnabledStatus: 'idle',
    getIsContractBreakConditionPeriodTypeEnabledError: undefined as any,
    getDefaultBreakConditionValuesStatus: 'idle',
    getDefaultBreakConditionValuesError: undefined as any,
    getDefaultOptionConditionValuesStatus: 'idle',
    getDefaultOptionConditionValuesError: undefined as any,
    getIsContractBreakConditionNichtVOKRelevantEnabledStatus: 'idle',
    getIsContractBreakConditionNichtVOKRelevantEnabledError: undefined as any,

    flvtgList: [] as any[],
    breakCond: undefined as any,
    breakConditionDefaultValues: undefined as any,
    contractOptionConditionList: [] as any,
    isContractBreakConditionNichtVOKRelevantEnabled: undefined as any,
    isContractBreakConditionPeriodTypeEnabled: undefined as any,
    isContractBreakConditionValidPeriodEnabled: undefined as any,
    optionCond: undefined as any,
    optionConditionDefaultValues: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractBreakConditionList = createAsyncThunk('flvtgSlice/loadContractBreakConditionList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flvtgSlice.loadContractBreakConditionListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flvtg/?action=gte&min_obj=${parentModel.OBJNR}&max_obj=${parentModel.OBJNR + 1}&min_pno=${parentModel.PNO}&max_pno=${parentModel.PNO}&min_flno=${parentModel.FLSTMNR}&max_flno=${parentModel.FLSTMNR}&min_flbeg=${parentModel.BEGIN}&max_flbeg=${parentModel.BEGIN}&min_typ=1&max_typ=1&min_vtrendedatum=${parentModel.END}&max_vtrendedatum=${parentModel.END}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractBreakConditionListStatus } = getState().flvtgSlice
        return loadContractBreakConditionListStatus !== 'pending'
    }
})

export const loadContractBreakCondition = createAsyncThunk('flvtgSlice/loadContractBreakCondition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flvtg/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractBreakConditionStatus } = getState().flvtgSlice
        return loadContractBreakConditionStatus !== 'pending'
    }
})

export const loadContractOptionConditionList = createAsyncThunk('flvtgSlice/loadContractOptionConditionList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flvtgSlice.loadContractOptionConditionListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flvtg/?action=gte&min_obj=${parentModel.OBJNR}&max_obj=${parentModel.OBJNR + 1}&min_pno=${parentModel.PNO}&max_pno=${parentModel.PNO}&min_flno=${parentModel.FLSTMNR}&max_flno=${parentModel.FLSTMNR}&min_flbeg=${parentModel.BEGIN}&max_flbeg=${parentModel.BEGIN}&min_typ=2&max_typ=2&min_vtrendedatum=${parentModel.END}&max_vtrendedatum=${parentModel.END}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractOptionConditionListStatus } = getState().flvtgSlice
        return loadContractOptionConditionListStatus !== 'pending'
    }
})

export const loadContractOptionCondition = createAsyncThunk('flvtgSlice/loadContractOptionCondition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flvtg/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractOptionConditionStatus } = getState().flvtgSlice
        return loadContractOptionConditionStatus !== 'pending'
    }
})

export const saveContractBreakCondition = createAsyncThunk('flvtgSlice/saveContractBreakCondition', async ({ flvtg }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flvtg?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/Contract_SaveBreakCondition/${ flvtg?.HDR_ID }/`,
            prepareData(flvtg),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/Contract_SaveBreakCondition/`,
            prepareData(flvtg),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractBreakConditionStatus } = getState().flvtgSlice
        return saveContractBreakConditionStatus !== 'pending'
    }
})

export const saveContractOptionCondition = createAsyncThunk('flvtgSlice/saveContractOptionCondition', async ({ flvtg }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flvtg?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/Contract_SaveOptionCondition/${ flvtg?.HDR_ID }/`,
            prepareData(flvtg),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/Contract_SaveOptionCondition/`,
            prepareData(flvtg),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractOptionConditionStatus } = getState().flvtgSlice
        return saveContractOptionConditionStatus !== 'pending'
    }
})

export const deleteContractBreakCondition = createAsyncThunk('flvtgSlice/deleteContractBreakCondition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flvtg/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractBreakConditionStatus } = getState().flvtgSlice
        return deleteContractBreakConditionStatus !== 'pending'
    }
})

export const deleteContractOptionCondition = createAsyncThunk('flvtgSlice/deleteContractOptionCondition', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flvtg/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractOptionConditionStatus } = getState().flvtgSlice
        return deleteContractOptionConditionStatus !== 'pending'
    }
})

export const getIsContractBreakConditionValidPeriodEnabled = createAsyncThunk('flvtgSlice/getIsContractBreakConditionValidPeriodEnabled', async ({ flvtg }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/contractBreakConditionIsValidEnabled/${flvtg.TYP}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { getIsContractBreakConditionValidPeriodEnabledStatus } = getState().flvtgSlice
        return getIsContractBreakConditionValidPeriodEnabledStatus !== 'pending'
    }
})

export const getIsContractBreakConditionPeriodTypeEnabled = createAsyncThunk('flvtgSlice/getIsContractBreakConditionPeriodTypeEnabled', async ({ flvtg }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/contractBreakConditionIsPeriodTypeEnabled/${flvtg.TYP}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { getIsContractBreakConditionPeriodTypeEnabledStatus } = getState().flvtgSlice
        return getIsContractBreakConditionPeriodTypeEnabledStatus !== 'pending'
    }
})

export const getDefaultBreakConditionValues = createAsyncThunk('flvtgSlice/getDefaultBreakConditionValues', async ({ parentModel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/Contract_CalcNewBreakConditionDefaultValues/?FLBELID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { getDefaultBreakConditionValuesStatus } = getState().flvtgSlice
        return getDefaultBreakConditionValuesStatus !== 'pending'
    }
})

export const getDefaultOptionConditionValues = createAsyncThunk('flvtgSlice/getDefaultOptionConditionValues', async ({ parentModel }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/Contract_CalcNewOptionDefaultValues/?FLBELID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { getDefaultOptionConditionValuesStatus } = getState().flvtgSlice
        return getDefaultOptionConditionValuesStatus !== 'pending'
    }
})

export const getIsContractBreakConditionNichtVOKRelevantEnabled = createAsyncThunk('flvtgSlice/getIsContractBreakConditionNichtVOKRelevantEnabled', async ({ flvtg }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/contractBreakConditionIsNichtVOKRelevantEnabled/${flvtg.SONDERTYP}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { getIsContractBreakConditionNichtVOKRelevantEnabledStatus } = getState().flvtgSlice
        return getIsContractBreakConditionNichtVOKRelevantEnabledStatus !== 'pending'
    }
})

const FlvtgSlice = createSlice({
    name: 'flvtgSlice',
    initialState,
    reducers: {
        resetloadContractBreakConditionListError: (state) => {
            state.loadContractBreakConditionListError = undefined
        },
        resetloadContractBreakCondition: (state) => {
            state.breakCond = undefined
            state.loadContractBreakConditionError = undefined
        },
        resetloadContractBreakConditionError: (state) => {
            state.loadContractBreakConditionError = undefined
        },
        resetloadContractOptionConditionList: (state) => {
            state.contractOptionConditionList = undefined
            state.loadContractOptionConditionListError = undefined
        },
        resetloadContractOptionConditionListError: (state) => {
            state.loadContractOptionConditionListError = undefined
        },
        resetloadContractOptionCondition: (state) => {
            state.optionCond = undefined
            state.loadContractOptionConditionError = undefined
        },
        resetloadContractOptionConditionError: (state) => {
            state.loadContractOptionConditionError = undefined
        },
        resetsaveContractBreakCondition: (state) => {
            state.breakCond = undefined
            state.saveContractBreakConditionError = undefined
        },
        resetsaveContractBreakConditionError: (state) => {
            state.saveContractBreakConditionError = undefined
        },
        resetsaveContractOptionCondition: (state) => {
            state.optionCond = undefined
            state.saveContractOptionConditionError = undefined
        },
        resetsaveContractOptionConditionError: (state) => {
            state.saveContractOptionConditionError = undefined
        },
        resetdeleteContractBreakConditionError: (state) => {
            state.deleteContractBreakConditionError = undefined
        },
        resetdeleteContractOptionConditionError: (state) => {
            state.deleteContractOptionConditionError = undefined
        },
        resetgetIsContractBreakConditionValidPeriodEnabled: (state) => {
            state.isContractBreakConditionValidPeriodEnabled = undefined
            state.getIsContractBreakConditionValidPeriodEnabledError = undefined
        },
        resetgetIsContractBreakConditionValidPeriodEnabledError: (state) => {
            state.getIsContractBreakConditionValidPeriodEnabledError = undefined
        },
        resetgetIsContractBreakConditionPeriodTypeEnabled: (state) => {
            state.isContractBreakConditionPeriodTypeEnabled = undefined
            state.getIsContractBreakConditionPeriodTypeEnabledError = undefined
        },
        resetgetIsContractBreakConditionPeriodTypeEnabledError: (state) => {
            state.getIsContractBreakConditionPeriodTypeEnabledError = undefined
        },
        resetgetDefaultBreakConditionValues: (state) => {
            state.breakConditionDefaultValues = undefined
            state.getDefaultBreakConditionValuesError = undefined
        },
        resetgetDefaultBreakConditionValuesError: (state) => {
            state.getDefaultBreakConditionValuesError = undefined
        },
        resetgetDefaultOptionConditionValues: (state) => {
            state.optionConditionDefaultValues = undefined
            state.getDefaultOptionConditionValuesError = undefined
        },
        resetgetDefaultOptionConditionValuesError: (state) => {
            state.getDefaultOptionConditionValuesError = undefined
        },
        resetgetIsContractBreakConditionNichtVOKRelevantEnabled: (state) => {
            state.isContractBreakConditionNichtVOKRelevantEnabled = undefined
            state.getIsContractBreakConditionNichtVOKRelevantEnabledError = undefined
        },
        resetgetIsContractBreakConditionNichtVOKRelevantEnabledError: (state) => {
            state.getIsContractBreakConditionNichtVOKRelevantEnabledError = undefined
        },
        removeFromFlvtgListById: (state, action) => {
            state.flvtgList = state.flvtgList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlvtgListByIds: (state, action) => {
            state.flvtgList = state.flvtgList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        removeFromContractOptionConditionListById: (state, action) => {
            state.contractOptionConditionList = state.contractOptionConditionList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromContractOptionConditionListByIds: (state, action) => {
            state.contractOptionConditionList = state.contractOptionConditionList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flvtgList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractBreakConditionListStatus = 'preloaded'
            state.loadContractBreakConditionListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flvtgList = []
            state.loadContractBreakConditionListStatus = 'idle'
            state.loadContractBreakConditionListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractBreakConditionList.pending, (state) => {
            state.loadContractBreakConditionListStatus = 'pending'
            state.loadContractBreakConditionListError = undefined
        })
        builder.addCase(loadContractBreakConditionList.fulfilled, (state, action) => {
            state.loadContractBreakConditionListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractBreakConditionListLastArgs = action.payload.args

            {
                state.flvtgList = action.payload.data

            }
        })
        builder.addCase(loadContractBreakConditionList.rejected, (state, action) => {
            state.loadContractBreakConditionListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractBreakConditionListError = action.error.message
            } else {
                state.loadContractBreakConditionListError = action.payload
            }
        })

        builder.addCase(loadContractBreakCondition.pending, (state) => {
            state.loadContractBreakConditionStatus = 'pending'
            state.loadContractBreakConditionError = undefined
        })
        builder.addCase(loadContractBreakCondition.fulfilled, (state, action) => {
            state.loadContractBreakConditionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.breakCond = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flvtgList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flvtgList.push(newItem) }
                else { state.flvtgList[i] = { ...state.flvtgList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractBreakCondition.rejected, (state, action) => {
            state.loadContractBreakConditionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractBreakConditionError = action.error.message
            } else {
                state.loadContractBreakConditionError = action.payload
            }
        })

        builder.addCase(loadContractOptionConditionList.pending, (state) => {
            state.loadContractOptionConditionListStatus = 'pending'
            state.loadContractOptionConditionListError = undefined
        })
        builder.addCase(loadContractOptionConditionList.fulfilled, (state, action) => {
            state.loadContractOptionConditionListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractOptionConditionListLastArgs = action.payload.args

            {
                state.contractOptionConditionList = action.payload.data

            }
        })
        builder.addCase(loadContractOptionConditionList.rejected, (state, action) => {
            state.loadContractOptionConditionListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractOptionConditionListError = action.error.message
            } else {
                state.loadContractOptionConditionListError = action.payload
            }
        })

        builder.addCase(loadContractOptionCondition.pending, (state) => {
            state.loadContractOptionConditionStatus = 'pending'
            state.loadContractOptionConditionError = undefined
        })
        builder.addCase(loadContractOptionCondition.fulfilled, (state, action) => {
            state.loadContractOptionConditionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.optionCond = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.contractOptionConditionList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.contractOptionConditionList.push(newItem) }
                else { state.contractOptionConditionList[i] = { ...state.contractOptionConditionList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractOptionCondition.rejected, (state, action) => {
            state.loadContractOptionConditionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractOptionConditionError = action.error.message
            } else {
                state.loadContractOptionConditionError = action.payload
            }
        })

        builder.addCase(saveContractBreakCondition.pending, (state) => {
            state.saveContractBreakConditionStatus = 'pending'
            state.saveContractBreakConditionError = undefined
        })
        builder.addCase(saveContractBreakCondition.fulfilled, (state, action) => {
            state.saveContractBreakConditionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.breakCond = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flvtgList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flvtgList.push(newItem) }
                else { state.flvtgList[i] = { ...state.flvtgList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractBreakCondition.rejected, (state, action) => {
            state.saveContractBreakConditionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractBreakConditionError = action.error.message
            } else {
                state.saveContractBreakConditionError = action.payload
            }
        })

        builder.addCase(saveContractOptionCondition.pending, (state) => {
            state.saveContractOptionConditionStatus = 'pending'
            state.saveContractOptionConditionError = undefined
        })
        builder.addCase(saveContractOptionCondition.fulfilled, (state, action) => {
            state.saveContractOptionConditionStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.optionCond = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flvtgList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flvtgList.push(newItem) }
                else { state.flvtgList[i] = { ...state.flvtgList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractOptionCondition.rejected, (state, action) => {
            state.saveContractOptionConditionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractOptionConditionError = action.error.message
            } else {
                state.saveContractOptionConditionError = action.payload
            }
        })

        builder.addCase(deleteContractBreakCondition.pending, (state) => {
            state.deleteContractBreakConditionStatus = 'pending'
            state.deleteContractBreakConditionError = undefined
        })
        builder.addCase(deleteContractBreakCondition.fulfilled, (state, action) => {
            state.deleteContractBreakConditionStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flvtgList = state.flvtgList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flvtgList = state.flvtgList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractBreakCondition.rejected, (state, action) => {
            state.deleteContractBreakConditionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractBreakConditionError = action.error.message
            } else {
                state.deleteContractBreakConditionError = action.payload
            }
        })

        builder.addCase(deleteContractOptionCondition.pending, (state) => {
            state.deleteContractOptionConditionStatus = 'pending'
            state.deleteContractOptionConditionError = undefined
        })
        builder.addCase(deleteContractOptionCondition.fulfilled, (state, action) => {
            state.deleteContractOptionConditionStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.contractOptionConditionList = state.contractOptionConditionList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.contractOptionConditionList = state.contractOptionConditionList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractOptionCondition.rejected, (state, action) => {
            state.deleteContractOptionConditionStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractOptionConditionError = action.error.message
            } else {
                state.deleteContractOptionConditionError = action.payload
            }
        })

        builder.addCase(getIsContractBreakConditionValidPeriodEnabled.pending, (state) => {
            state.getIsContractBreakConditionValidPeriodEnabledStatus = 'pending'
            state.getIsContractBreakConditionValidPeriodEnabledError = undefined
        })
        builder.addCase(getIsContractBreakConditionValidPeriodEnabled.fulfilled, (state, action) => {
            state.getIsContractBreakConditionValidPeriodEnabledStatus = 'idle'

            {
                state.isContractBreakConditionValidPeriodEnabled = action.payload

            }
        })
        builder.addCase(getIsContractBreakConditionValidPeriodEnabled.rejected, (state, action) => {
            state.getIsContractBreakConditionValidPeriodEnabledStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.getIsContractBreakConditionValidPeriodEnabledError = action.error.message
            } else {
                state.getIsContractBreakConditionValidPeriodEnabledError = action.payload
            }
        })

        builder.addCase(getIsContractBreakConditionPeriodTypeEnabled.pending, (state) => {
            state.getIsContractBreakConditionPeriodTypeEnabledStatus = 'pending'
            state.getIsContractBreakConditionPeriodTypeEnabledError = undefined
        })
        builder.addCase(getIsContractBreakConditionPeriodTypeEnabled.fulfilled, (state, action) => {
            state.getIsContractBreakConditionPeriodTypeEnabledStatus = 'idle'

            {
                state.isContractBreakConditionPeriodTypeEnabled = action.payload

            }
        })
        builder.addCase(getIsContractBreakConditionPeriodTypeEnabled.rejected, (state, action) => {
            state.getIsContractBreakConditionPeriodTypeEnabledStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.getIsContractBreakConditionPeriodTypeEnabledError = action.error.message
            } else {
                state.getIsContractBreakConditionPeriodTypeEnabledError = action.payload
            }
        })

        builder.addCase(getDefaultBreakConditionValues.pending, (state) => {
            state.getDefaultBreakConditionValuesStatus = 'pending'
            state.getDefaultBreakConditionValuesError = undefined
        })
        builder.addCase(getDefaultBreakConditionValues.fulfilled, (state, action) => {
            state.getDefaultBreakConditionValuesStatus = 'idle'

            {
                state.breakConditionDefaultValues = action.payload

            }
        })
        builder.addCase(getDefaultBreakConditionValues.rejected, (state, action) => {
            state.getDefaultBreakConditionValuesStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.getDefaultBreakConditionValuesError = action.error.message
            } else {
                state.getDefaultBreakConditionValuesError = action.payload
            }
        })

        builder.addCase(getDefaultOptionConditionValues.pending, (state) => {
            state.getDefaultOptionConditionValuesStatus = 'pending'
            state.getDefaultOptionConditionValuesError = undefined
        })
        builder.addCase(getDefaultOptionConditionValues.fulfilled, (state, action) => {
            state.getDefaultOptionConditionValuesStatus = 'idle'

            {
                state.optionConditionDefaultValues = action.payload

            }
        })
        builder.addCase(getDefaultOptionConditionValues.rejected, (state, action) => {
            state.getDefaultOptionConditionValuesStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.getDefaultOptionConditionValuesError = action.error.message
            } else {
                state.getDefaultOptionConditionValuesError = action.payload
            }
        })

        builder.addCase(getIsContractBreakConditionNichtVOKRelevantEnabled.pending, (state) => {
            state.getIsContractBreakConditionNichtVOKRelevantEnabledStatus = 'pending'
            state.getIsContractBreakConditionNichtVOKRelevantEnabledError = undefined
        })
        builder.addCase(getIsContractBreakConditionNichtVOKRelevantEnabled.fulfilled, (state, action) => {
            state.getIsContractBreakConditionNichtVOKRelevantEnabledStatus = 'idle'

            {
                state.isContractBreakConditionNichtVOKRelevantEnabled = action.payload

            }
        })
        builder.addCase(getIsContractBreakConditionNichtVOKRelevantEnabled.rejected, (state, action) => {
            state.getIsContractBreakConditionNichtVOKRelevantEnabledStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.getIsContractBreakConditionNichtVOKRelevantEnabledError = action.error.message
            } else {
                state.getIsContractBreakConditionNichtVOKRelevantEnabledError = action.payload
            }
        })

    }
})

export const {
    resetloadContractBreakConditionListError,
    resetloadContractBreakCondition,
    resetloadContractBreakConditionError,
    resetloadContractOptionConditionList,
    resetloadContractOptionConditionListError,
    resetloadContractOptionCondition,
    resetloadContractOptionConditionError,
    resetsaveContractBreakCondition,
    resetsaveContractBreakConditionError,
    resetsaveContractOptionCondition,
    resetsaveContractOptionConditionError,
    resetdeleteContractBreakConditionError,
    resetdeleteContractOptionConditionError,
    resetgetIsContractBreakConditionValidPeriodEnabled,
    resetgetIsContractBreakConditionValidPeriodEnabledError,
    resetgetIsContractBreakConditionPeriodTypeEnabled,
    resetgetIsContractBreakConditionPeriodTypeEnabledError,
    resetgetDefaultBreakConditionValues,
    resetgetDefaultBreakConditionValuesError,
    resetgetDefaultOptionConditionValues,
    resetgetDefaultOptionConditionValuesError,
    resetgetIsContractBreakConditionNichtVOKRelevantEnabled,
    resetgetIsContractBreakConditionNichtVOKRelevantEnabledError,
    removeFromFlvtgListById,
    removeFromFlvtgListByIds,
    removeFromContractOptionConditionListById,
    removeFromContractOptionConditionListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlvtgSlice.actions
export default FlvtgSlice.reducer
